var _rect, _circle, _path, _path2, _path3, _path4, _mask, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlavor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 104,
    viewBox: "0 0 139 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 104,
    transform: "translate(0.599976)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.6,
    cy: 54.625,
    r: 18,
    fill: "#FFA800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7957 28.136C51.0237 31.7317 53.1131 39.7725 53.1131 39.7725C53.1131 39.7725 45.1049 41.9834 38.8768 38.3877C32.6488 34.7919 30.5594 26.7511 30.5594 26.7511C30.5594 26.7511 38.5676 24.5402 44.7957 28.136Z",
    fill: "#0C9F7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6 39.625C52.6 36.9649 53.7428 31.2459 60.6 31.6448",
    stroke: "#826161",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0625 35.3013C84.8108 30.2556 88.6285 25.375 93.8272 25.375H101.123C106.321 25.375 110.139 30.2556 108.887 35.3013L106.38 45.4094C105.365 49.5015 101.691 52.375 97.475 52.375C93.2588 52.375 89.5854 49.5015 88.5702 45.4094L86.0625 35.3013Z",
    fill: "#D62020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4751 21.625C102.653 21.625 106.85 25.75 106.85 25.75C106.85 25.75 102.653 29.875 97.4751 29.875C92.2974 29.875 88.1001 25.75 88.1001 25.75C88.1001 25.75 92.2974 21.625 97.4751 21.625Z",
    fill: "#0C9F7C"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_10294_144673",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6 68.375C83.6 66.1659 85.3908 64.375 87.6 64.375H107.6C109.809 64.375 111.6 66.1659 111.6 68.375V78.375C111.6 80.5841 109.809 82.375 107.6 82.375H87.6C85.3908 82.375 83.6 80.5841 83.6 78.375V68.375Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6 68.375C83.6 66.1659 85.3908 64.375 87.6 64.375H107.6C109.809 64.375 111.6 66.1659 111.6 68.375V78.375C111.6 80.5841 109.809 82.375 107.6 82.375H87.6C85.3908 82.375 83.6 80.5841 83.6 78.375V68.375Z",
    fill: "#B6765B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6 64.375H111.6H83.6ZM111.6 78.375C111.6 82.241 108.466 85.375 104.6 85.375H87.6C83.734 85.375 80.6 82.241 80.6 78.375H86.6C86.6 78.9273 87.0477 79.375 87.6 79.375H107.6C109.809 79.375 111.6 78.9273 111.6 78.375ZM87.6 85.375C83.734 85.375 80.6 82.241 80.6 78.375V71.375C80.6 67.509 83.734 64.375 87.6 64.375C87.0477 64.375 86.6 66.1659 86.6 68.375V78.375C86.6 78.9273 87.0477 79.375 87.6 79.375V85.375ZM111.6 64.375V82.375V64.375Z",
    fill: "#7D430D",
    mask: "url(#path-6-inside-1_10294_144673)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlavor);
export default __webpack_public_path__ + "static/media/flavor.481fa704e3ba5e9ba5319554c5ae49ed.svg";
export { ForwardRef as ReactComponent };